import { render, staticRenderFns } from "./ReportCardGradingList.vue?vue&type=template&id=7fa3fbea&scoped=true"
import script from "@/controllers/custom/report_card_grading/report-card-grading-list.js?vue&type=script&lang=js&external"
export * from "@/controllers/custom/report_card_grading/report-card-grading-list.js?vue&type=script&lang=js&external"
import style0 from "./ReportCardGradingList.vue?vue&type=style&index=0&id=7fa3fbea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa3fbea",
  null
  
)

export default component.exports